<template>
  <div id="app" class="h-screen overflow-hidden bg-gray-50">
    <RouterView v-slot="{ Component, route }">
      <KeepAlive v-if="route.meta.keepAlive">
        <component :is="Component" :key="route.name" />
      </KeepAlive>
      <component v-else :is="Component" />
    </RouterView>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

onMounted(() => {
  // Initialize user authentication check
  userStore.checkAuth()
})
</script>
